import React from "react";
import styled from "styled-components";

export interface ILogoProps {
  url: string;
  size?: number;
  borderRadius?: string;
}

export const Logo = ({ url, size, borderRadius, ...rest }: ILogoProps) => {
  const logoSize = size ? `${size}em` : undefined;
  return (
    <LogoStyled
      className="logo"
      style={{ width: logoSize, height: logoSize }}
      {...rest}
    >
      <LogoImageStyled src={url} alt="" style={{ borderRadius }} />
    </LogoStyled>
  );
};

const LogoStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
`;

const LogoImageStyled = styled.img`
  max-width: 100%;
`;
